import angular from 'angular'

import marketplaceHomeModule from './marketplaceHome/marketplaceHome'
import loanRequestDetailsModule from './loanRequestDetails/loanRequestDetails'

export default angular.module('app.pages.marketplace', [
  marketplaceHomeModule.name,
  loanRequestDetailsModule.name
])
